import { CardContent, FormControl, FormControlLabel, Checkbox, FormHelperText, Typography, Box } from '@mui/material';
import type { FormikProps } from 'formik';

interface TermsAndConditionsProps {
	formik?: FormikProps<{ tncAccepted: boolean }>;
	isBulkRequest?: boolean;
}

export const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({ formik, isBulkRequest = false }) => {
	if (!formik) {
		return null;
	}

	const hasError = Boolean(formik.touched.tncAccepted && formik.errors.tncAccepted);

	let tnc = 'https://ausrehab.com/pes-terms-and-conditions/';

	if (isBulkRequest) {
		tnc = 'https://www.ausrehab.com/bulk-pes-terms-and-conditions/';
	}

	return (
		<CardContent sx={{ pt: 0 }}>
			<FormControl component="fieldset" variant="standard" error={hasError}>
				<FormHelperText sx={{ visibility: hasError ? 'visible' : 'hidden' }}>
					{formik.errors.tncAccepted || ' '}
				</FormHelperText>
				<FormControlLabel
					control={
						<Checkbox
							name="tncAccepted"
							onChange={(e) => {
								formik.setFieldValue('tncAccepted', e.target.checked);
							}}
						/>
					}
					label={
						<Box>
							I have read and agree to the {''}
							<a href={tnc} target="_blank" rel="noreferrer">
								Terms and Conditions
							</a>
						</Box>
					}
				/>
			</FormControl>
			<Typography variant="subtitle2" sx={{ ml: 4 }}>
				*Please have your credit or debit card ready for payment on the next page.
			</Typography>
		</CardContent>
	);
};
